import React, {Component} from "react";
import ContentWrapper from '../Layout/ContentWrapper';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import {API_ROOT} from '../../api-config';
import Swal from 'sweetalert2'

class ImportLCBOOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            uploading: false,
            results: null,
            dragOver: false,
        };
        this.inputRef = React.createRef();
        this.dropRef = React.createRef();
    }

    handleFileChange = (e) => {
        const selected = Array.from(e.target.files).filter(f => f.type === 'application/pdf');
        if (selected.length > 0) {
            this.setState({files: [...this.state.files, ...selected]});
        }
    };

    handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({dragOver: true});
    };

    handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({dragOver: false});
    };

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({dragOver: false});
        const dropped = Array.from(e.dataTransfer.files).filter(f => f.type === 'application/pdf');
        if (dropped.length > 0) {
            this.setState({files: [...this.state.files, ...dropped]});
        }
    };

    removeFile = (index) => {
        const files = [...this.state.files];
        files.splice(index, 1);
        this.setState({files});
    };

    handleUpload = () => {
        const {files} = this.state;
        if (files.length === 0) return alert("Please select at least one PDF file");

        this.setState({uploading: true, results: null});

        const formData = new FormData();
        files.forEach((file) => {
            formData.append('pdfs', file);
        });

        axios.defaults.withCredentials = true;
        axios.post(API_ROOT + "/import_lcbo_orders/", formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        })
            .then(response => {
                this.setState({uploading: false, results: response.data.results, files: []});
            })
            .catch(error => {
                this.setState({uploading: false});
                if (error.response) {
                    if (error.response.status === 401) {
                        this.props.userSignOut();
                    } else {
                        Swal("Error", error.response.data.Message || "An error occurred", "error");
                    }
                } else {
                    Swal("Error", "Network error", "error");
                }
            });
    };

    render() {
        const {files, uploading, results, dragOver} = this.state;

        return (
            <ContentWrapper>
                <div className="content-heading">
                    Import LCBO Purchase Orders
                </div>
                <div className="card card-default">
                    <div className="card-body">
                        <p>Use this page to import LCBO purchase order PDFs. You can select or drag &amp; drop multiple files.</p>

                        <div
                            ref={this.dropRef}
                            onDragOver={this.handleDragOver}
                            onDragLeave={this.handleDragLeave}
                            onDrop={this.handleDrop}
                            onClick={() => this.inputRef.current.click()}
                            style={{
                                border: dragOver ? '2px dashed #007bff' : '2px dashed #ccc',
                                borderRadius: '8px',
                                padding: '40px 20px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                backgroundColor: dragOver ? '#e8f0fe' : '#fafafa',
                                marginBottom: '15px',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <i className="fas fa-file-pdf fa-2x" style={{color: '#dc3545', marginBottom: '10px'}}></i>
                            <p style={{margin: 0, color: '#666'}}>
                                Drag &amp; drop PDF files here, or click to browse
                            </p>
                        </div>

                        <input
                            type="file"
                            accept=".pdf"
                            multiple
                            ref={this.inputRef}
                            onChange={this.handleFileChange}
                            style={{display: 'none'}}
                        />

                        {files.length > 0 && (
                            <div className="mb-3">
                                <strong>{files.length} file{files.length !== 1 ? 's' : ''} selected:</strong>
                                <ul className="list-group mt-2">
                                    {files.map((file, i) => (
                                        <li key={i} className="list-group-item d-flex justify-content-between align-items-center">
                                            <span><i className="fas fa-file-pdf text-danger mr-2"></i>{file.name}</span>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.removeFile(i);
                                                }}
                                            >
                                                <i className="fas fa-times"></i>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        <button
                            onClick={this.handleUpload}
                            className="btn btn-primary"
                            disabled={uploading || files.length === 0}
                        >
                            {uploading ? 'Uploading...' : 'Upload'}
                        </button>

                        {uploading && (
                            <div className="mt-3">
                                <div className="alert alert-info">
                                    <i className="fas fa-spinner fa-spin mr-2"></i>
                                    Uploading and processing PDFs... please wait.
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {results && results.length > 0 && (
                    <div className="card card-default">
                        <div className="card-header">
                            <h4 className="card-title">Import Results</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                    <tr>
                                        <th>PO</th>
                                        <th>Already Exists?</th>
                                        <th>Order #</th>
                                        <th>Ship Date</th>
                                        <th>Errors</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {results.map((r, i) => (
                                        <tr key={i} className={r.error ? 'table-danger' : (r.error ? 'table-warning' : (r.already_exists ? 'table-warning' : 'table-success'))}>
                                            <td>{r.po || 'N/A'}</td>
                                            <td>{r.already_exists ? 'Yes' : 'No'}</td>
                                            <td>{r.order_id ? <span className="text-primary" style={{cursor: 'pointer', textDecoration: 'underline'}}
                                                                    onClick={() => this.props.history.push(`/order/${r.order_id}`)}>{r.order_id}</span> : 'N/A'}</td>
                                            <td>{r.ship_date || 'N/A'}</td>
                                            <td>{r.error || ''}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </ContentWrapper>
        );
    }
}

export default ImportLCBOOrders;
